import React from 'react';
import styled from 'styled-components';
import { Ribbon } from '@99designs/frontend-components/components/Ribbon';
import BoxWithGradient from '../../../components/BoxWithGradient';
import TabbedContent from '../../../components/TabbedContent';
import { borders, media } from '../../../lib/styles';
import Box from '../../../spa/core-components/Box';
import Attribution from '../../Attribution';
import DesignCard from '../../DesignCard';
import { DesignWithMetaCard } from '../Card';
import DetailsTabContent from './DetailsTabContent';
import ReviewTabContent from './ReviewTabContent';

const StyledCard = styled(DesignWithMetaCard)`
    width: 320px;
    height: 680px;
    border-radius: 0 0 ${borders.borderRadiuses.large}px ${borders.borderRadiuses.large}px;

    @media ${media('small')} {
        width: 270px;
        height: 620px;
    }

    > * {
        &:last-child {
            border-top: ${borders.content};

            > * {
                &:last-child {
                    height: 100%;
                }
            }
        }
    }
`;

export type PackageType = 'BRONZE' | 'SILVER' | 'GOLD' | 'PLATINUM' | 'CUSTOM';

interface Design {
    url: string;
    alt: string;
    designerName: string;
}

export interface ClientReview {
    rating: number;
    review: string;
}

export interface Contest {
    title: string;
    description: string;
    entriesTotal: number;
    designersTotal: number;
    url: string;
    packageType: PackageType;
}

export interface Props {
    design: Design;
    clientReview: ClientReview;
    clientName: string;
    contest: Contest;
    avatarUrl: string;
    onTabChange?: (id: string) => void;
}

function ReviewCard({ design, onTabChange, ...props }: Props) {
    return (
        <StyledCard
            image={
                <Box
                    width={['270px', '320px', '320px', '320px']}
                    height={['270px', '320px', '320px', '320px']}
                >
                    <DesignCard
                        src={design.url}
                        alt={design.alt}
                        ribbon={<Ribbon variations={['medium']}>{__('Winner')}</Ribbon>}
                        width={320}
                        height={320}
                        designMetaContent={
                            <BoxWithGradient padding="space7">
                                <Attribution name={design.designerName} color="white" />
                            </BoxWithGradient>
                        }
                    />
                </Box>
            }
            meta={
                <TabbedContent
                    data={[
                        {
                            id: 'client-review',
                            title: __('Review'),
                            content: (
                                <ReviewTabContent
                                    clientReview={props.clientReview}
                                    clientName={props.clientName}
                                    avatarUrl={props.avatarUrl}
                                />
                            ),
                        },
                        {
                            id: 'review-contest-details',
                            title: __('Details'),
                            content: <DetailsTabContent contest={props.contest} />,
                        },
                    ]}
                    onChange={onTabChange && onTabChange}
                />
            }
        />
    );
}

export default ReviewCard;
